<template>
    <v-layout
      v-if="screen==='permission'"
      align-center
      justify-center
      row
      wrap
      style="position: relative"
    >
      <v-flex xs12 sm12 md12 lg6 xl6 style="background-color: white">
        <v-container v-if="!this.modelDownloading">
          <v-layout align-center justify-center column wrap>
            <span class="ageai-title">AgeAI</span>
            <v-layout align-center justify-center style="margin-top: 10px" :style="{ width: imageWidth }">
              <v-flex xs12>
                <span class="arcoscan-subtitle"
                  >Our technology employs facial scan to estimate a user's age and ascertain the need for an ID check. The demo operates for a duration of {{timelimit}} seconds. Please be aware that anti-spoof measures are not integrated into this demo. To start, kindly press the button below to activate your camera. </span
                >
              </v-flex>
            </v-layout>
            <v-layout align-center justify-center style="margin-top: 24px">
              <v-img contain :src="require('@/assets/images/ageai/hero.png')" :width="imageWidth" />
            </v-layout>

            <v-flex xs12 class="large-checkbox" v-show="!disclaimerAgreed" style="margin-top: 30px">
              <v-checkbox v-model="disclaimerChecked" color="success"
                ><template v-slot:label>
                  <span id="checkboxLabel" style="color: black"
                    >I agree to let Privately process my data for this service.</span
                  >
                </template></v-checkbox
              ></v-flex
            >

            <v-flex xs12 style="margin-top: 20px"
              ><v-btn
                class="ageai-button"
                :disabled="!disclaimerChecked && !disclaimerAgreed"
                large
                color="#4E79A3"
                type="submit"
                @click="startVideo"
              >
                Start
              </v-btn></v-flex
            >
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>

    <!-- my code -->
  <v-layout v-else-if="screen==='faceestimate'">
    <v-container grid-list-md >
      <v-layout row wrap :style="{display:'flex','justify-content':'center'}">
        <v-flex id = "videocontain" xs12 sm12 md6 lg6 xl6>
          <div  class="camera-box" :style="{height:'auto',width:'auto','align-items': 'center'}"> 
                                    
            <video id='videocase' justify-center ref="video" autoplay playsinline webkit-playsinline :style="{borderColor:borderColor}" ></video>
            <canvas ref="canvasoverlay"  style="display:none ;position: absolute; background: transparent; top: 0%; right: 0; left: 0; left: 0%;pointer-events: none"></canvas>
            <v-flex xs12 :style="{'text-align': 'center','justify-content': 'center'}">
              <v-btn id="agegate-button21"
                  type="submit" @click="ageGate(21)">
                  Age Gate 21
              </v-btn>
              <v-btn id="agegate-button25"
                  type="submit" @click="ageGate(25)">
                  Age Gate 25
              </v-btn>
            </v-flex>
            <!-- <div class="card flex justify-content-center">
              <SelectButton v-model="value" :options="agegates" aria-labelledby="basic" />
            </div> -->
            <div class="text-container" width=100% height="auto" style="display:none;" >
            <div id="estimated_age" style="font-size: 14px;">Estimated age: - </div>
            <div id="lighting" style="font-size: 10px;">Lighting: - </div>
            <div id="blur" style="font-size: 10px;">Blur: -</div>
            <div id="head_tilt" style="font-size: 10px;">Head_tilt: -</div>
            <div id="head_left_right" style="font-size: 10px;">Head_left_right: -</div>
            <div id="head_up_down" style="font-size: 10px;">Head_up_down: -</div>
            </div>
            
                                            
                                      
          </div>
          <div class='result-message' :style="{color:messageColor}">{{ idCheckMessage }}</div>
          <div class='timer'>Timer: {{ timerCount }} Sec</div>
          
          
        </v-flex>
      </v-layout>
    </v-container>
  </v-layout>

  <v-layout
      v-else
      align-center
      justify-center
      row
      wrap
      style="position: relative"
    >
      <v-flex xs12 sm12 md12 lg6 xl6>
        <div class="thankmsg">Thank you for trying out Privately's AgeAI Demo!</div>
        <div class="linkmsg">
          For more demos and information, visit us at
          <a href="https://www.privately.eu/ageai-lp">Privately</a>
          .
        </div>
      </v-flex>
    </v-layout>
    
    
</template>
  
  <script>
  import axios from "axios";
// import { threadId } from "worker_threads";
  
  axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
  axios.defaults.withCredentials = false;
  
  
  export default {
    name: "AgeAI",
    data() {
      return {
          loading: false,
          predictioncl: "",
          isCameraOpen: false,
          isLoading: false,
          socket :null,
          video : null,
          ctx_overlay: null,
          lines: [], 
          screen:'permission',
          isMobile: false,
          modelDownloading: false,
          disclaimerChecked: false,
          disclaimerAgreed: false,
          estimated_age:'-',
          borderColor:'lightgrey',
          idCheckMessage: 'No face / Multiple faces',
          messageColor:'grey',
          agegates: ['Age Gate 21','Age Gate 25'],
          agelimit:21,
          timerCount:'-',
          timelimit:15,
          idinterval:0,
          face_detection:'false',
      };
    },
    computed: {
    imageWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "400px";
        case "sm":
          return "500px";
        case "md":
          return "684px";
        case "lg":
          return "684px";
        case "xl":
          return "684px";
      }
    },
    },
    watch:{
      estimated_age(val) {
        // Update the result message
        if (val>=this.agelimit){
          this.borderColor='lightgreen';
          this.idCheckMessage = "User older than "+this.agelimit+": ID check not required";
          this.messageColor = 'green';
        }
        else if (val < this.agelimit){
          this.borderColor='rgb(222, 77, 77)';
          this.idCheckMessage = "User younger than "+this.agelimit+": ID check required";
          this.messageColor = 'rgb(222, 77, 77)';
        }
        else{
          this.borderColor='lightgrey';
          this.messageColor = 'grey';
          // if (val == "Bad Env/Pose")
          // console.log("Check:"+val)
          if (this.face_detection == 'false'){
            this.idCheckMessage = 'No Face Detected';
          }
          else {
              if (val == 'Multiple Faces'){
                this.idCheckMessage = 'Multiple Faces';
              }
              else if (this.head_align!='straightstraightstraight'){
                this.idCheckMessage = 'Please look straight';
              }
              else if (this.lighting!='good'){
                this.idCheckMessage = 'Please be in a well-lit environment';
              }
              else{
              this.idCheckMessage = 'Unknown Error';
              }
            }
          
        }

      },
      agelimit(val){
        this.estimated_age_reload();
        var btn21 = document.getElementById('agegate-button21');
        var btn25 = document.getElementById('agegate-button25');
        if (val == 25){
          // console.log("Entered")
          btn25.style.setProperty('background-color', '#3aa56a', 'important'); 
          btn25.style.setProperty('color', 'black', 'important');
          btn25.style.setProperty('border-color', '#167d45', 'important');

          btn21.style.setProperty('background-color', 'white', 'important'); 
          btn21.style.setProperty('color', '#6eaae5', 'important');
          btn21.style.setProperty('border-color', '#6eaae5', 'important'); 
        
        }
        else{
          btn21.style.setProperty('background-color', '#3aa56a', 'important'); 
          btn21.style.setProperty('color', 'black', 'important');
          btn21.style.setProperty('border-color', '#167d45', 'important');

          btn25.style.setProperty('background-color', 'white', 'important'); 
          btn25.style.setProperty('color', '#6eaae5', 'important');
          btn25.style.setProperty('border-color', '#6eaae5', 'important'); 

        }
      },
      timerCount(val){
        if(val<=this.timelimit && val>=0){
          setTimeout(this.timerstart,1000);
        }
        else if(val<0){
          this.socketdisconnect();
        }


      }
      
    },
    mounted() {
    this.handleWindowResize(); // Call the function on initial mount
    // Add event listener for window resize
    window.addEventListener('resize', this.handleWindowResize);
    // this.toggleCamera();
    
    },
    beforeMount() {
      this.socketconnect();
    },
    beforeDestroy() {
      // Remove event listener when the component is destroyed
      window.removeEventListener('resize', this.handleWindowResize);
      this.socketdisconnect();
    },
    methods: {
      estimated_age_reload() {
        // Update the result message when limit is changed
        var val = this.estimated_age;
        if (val>=this.agelimit){
          this.borderColor='lightgreen';
          this.idCheckMessage = "User older than "+this.agelimit+": ID check not required";
          this.messageColor = 'green';
        }
        else if (val < this.agelimit){
          this.borderColor='rgb(222, 77, 77)';
          this.idCheckMessage = "User younger than "+this.agelimit+": ID check not required";
          this.messageColor = 'rgb(222, 77, 77)';
        }
        else{
          this.borderColor='lightgrey';
          this.messageColor = 'grey';
          // console.log("Randomcheck:"+this.estimated_age)
          if (this.face_detection == 'false'){
            this.idCheckMessage = 'No Face Detected';
          }
          else {
              if (val == 'Multiple Faces'){
                this.idCheckMessage = 'Multiple Faces';
              }
              else if (this.head_align!='straightstraightstraight'){
                this.idCheckMessage = 'Please look straight';
              }
              else if (this.lighting!='good'){
                this.idCheckMessage = 'Please be in a well-lit environment';
              }
              else{
              this.idCheckMessage = 'Unknown Error';
              }
            }
          
        }
      },
      handleWindowResize() {
        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;

        // Determine the shortest length (width or height)
        // const shortestLength = Math.max(windowWidth, windowHeight);

        // // Update the CSS property dynamically
        // this.containerStyle = {
        // width: `${shortestLength}px`,
        // height: `${shortestLength}px`,
        // };
      },
      socketconnect() {
          this.$socket = io('https://fallback-server-for-on-browser.privately.swiss:8999')
          // $socket is socket.io-client instance
          this.$socket.on("connect", () => {
            console.log('WebSocket connection established.');
            // captureVideo();
            });
      }, 
      socketdisconnect() {

        this.$socket.disconnect();
        clearInterval(this.idinterval);
        // $socket is socket.io-client instance
        this.$socket.on("disconnect", () => {
          console.log('WebSocket disconnected.');
          // captureVideo();
          });
        this.stopCamera();
        this.screen = 'endmessage';
      }, 
      clickButton(data) {
            // $socket is socket.io-client instance
            this.$socket.emit('emit_method', data)
      },
      sendtoparent(information){
          parent.postMessage(information,"*")
      },     
      toggleCamera() {
        // if(this.isCameraOpen) {
        //   this.isCameraOpen = false;
        //   this.socketdisconnect();
        //   this.stopCamera();
        //   document.getElementById("videocontain").style.textAlign = 'center'
        //   document.getElementById("stopbutton").style.display = 'none';
        //   document.getElementById("startbutton").style.display = 'inline-block';
  
        // } else {
          this.isCameraOpen = true;
          this.startCamera();
          document.getElementById("videocontain").style.textAlign = 'left'
          // document.getElementById("stopbutton").style.display = 'inline-block';
          // document.getElementById("startbutton").style.display = 'none';
          
        // }
      },
      drawLines(coordinates) {

        const canvasoverlay = this.$refs.canvasoverlay;
        const video = this.$refs.video;
        this.$ctx_overlay = canvasoverlay.getContext('2d');
        // console.log("videoWidth"+)
        this.$ctx_overlay.width = video.offsetWidth;
        this.$ctx_overlay.height = video.offsetHeight;
        // console.log("Width = "+video.offsetWidth + "height:" +video.offsetHeight)
        this.$ctx_overlay.clearRect(0, 0, video.offsetWidth , video.offsetHeight);

        this.$ctx_overlay.beginPath();
        this.$ctx_overlay.setLineDash([3, 5]);
        this.$ctx_overlay.strokeStyle = 'blue';
        this.$ctx_overlay.lineWidth = 0.1;

        for (let i = 0; i < coordinates.length; i++) {
          this.$ctx_overlay.moveTo(coordinates[i][0][0], coordinates[i][0][1]);
          this.$ctx_overlay.lineTo(coordinates[i][1][0], coordinates[i][1][1]);
          this.$ctx_overlay.stroke();
        }
      },
      updateResponse(data){
        // canvas.width = video.videoWidth;
        // canvas.height = video.videoHeight;
        // const ctx_overlay = this.$canvas_overlay.getContext("2d");

        // // Draw bounding box
        // ctx.strokeStyle = 'red';
        // ctx.lineWidth = 2;

        
        // this.drawLines(data['face_contours']);

        // ctx.fillStyle = 'blue';
        // ctx.font = '16px Arial';
        if ( data['estimated_age']=="Bad Env/Pose" || data['estimated_age']=='-') {
            document.getElementById("estimated_age").style.color = 'red';
        } else {
            document.getElementById("estimated_age").style.color = 'green';
        }
        if ( data['estimated_age']=='-'){
          data['estimated_age'] = 'No face detected'
        }
        document.getElementById('estimated_age').innerText = "Estimated age: " + data['estimated_age'];
        if ( data['lighting'][0]=='good') {
            document.getElementById("lighting").style.color = 'green';
        } else {
            document.getElementById("lighting").style.color = 'red';
        }
        document.getElementById("lighting").innerText = "Lighting: " + data['lighting'][0] 
        // + "(" + data['lighting'][1] + ")";

        document.getElementById("blur").innerText = "Blur: " + data['blur'][0] 
        // + "(" + data['blur'][1] + ")";

        if ( data['blur'][0]=='clear') {
            document.getElementById("blur").style.color = 'green';
        } else {
            document.getElementById("blur").style.color = 'red';
        }

        if ( data['head_tilt'][0]=='straight') {
            document.getElementById("head_tilt").style.color = 'green';
        } else {
            document.getElementById("head_tilt").style.color = 'red';
        }
        document.getElementById("head_tilt").innerText = "Head_tilt: "+data['head_tilt'][0] 
        // + "(" + data['head_tilt'][1] + ")";
        if ( data['head_left_right'][0]=='straight') {
            document.getElementById("head_left_right").style.color = 'green';
        } else {
            document.getElementById("head_left_right").style.color = 'red';
        }
        document.getElementById("head_left_right").innerText = "Head_left_right: " + data['head_left_right'][0] 
        // + "(" + data['head_left_right'][1] + ")";

        if ( data['head_up_down'][0]=='straight') {
            document.getElementById("head_up_down").style.color = 'green';
        } else {
            document.getElementById("head_up_down").style.color = 'red';
        }
        document.getElementById("head_up_down").innerText = "Head_up_down: " + data['head_up_down'][0] 
        // + "(" + data['head_up_down'][1] + ")";
      },

    startVideo() {
        // this.screen = 'faceestimate';
        this.isCameraOpen = true;
        // setTimeout(this.socketdisconnect,10000);
        
        this.startCamera();
        // this.timerCount = 10;
        // document.getElementById("videocontain").style.textAlign = 'left'
    },

    timerstart(){
      this.timerCount--;
    },

    startCamera() {
      // this.socketconnect();
      this.screen = 'faceestimate';
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({ video: true })
          .then((stream) => {
            this.videoStream = stream;
            this.$refs.video.srcObject = stream;
            
            this.startFrameRelay();
          })
          .catch((error) => {
            console.error('Error accessing camera:', error);
          });
      } else {
        console.error('getUserMedia is not supported');
      }

    },
    stopCamera() {
      // this.socketdisconnect();
      // clearInterval(thi);
      if (this.videoStream) {
        this.videoStream.getTracks().forEach((track) => {
          track.stop();
        });
        this.$refs.video.srcObject = null;
        this.stopFrameRelay();
      }
    },

      startFrameRelay() {
      // Get the canvas element
      const canvas = this.$refs.canvasoverlay;
      const context = canvas.getContext('2d');

      // Create a new image every 100ms and send it to the server
      this.timerCount = this.timelimit;
      this.idinterval = setInterval(() => {
        const frame_width = document.getElementById("videocase").offsetWidth;
        const frame_height = document.getElementById("videocase").offsetHeight;
        // console.log("Frame"+ frame_width + " "+ frame_height);
        // console.log("Canvas"+ canvas.width + " "+ canvas.height);
        canvas.width = frame_width;
        canvas.height = frame_height;
        context.drawImage(this.$refs.video, 0, 0,canvas.width,canvas.height);
        const imageData = canvas.toDataURL('image/jpeg');
        // Send the image data to the server via Socket.IO
        this.$socket.emit('image',{'image': imageData});
        // requestAnimationFrame(sendFrame);
        this.$socket.on('image_resp', (data) => {
        // console.log("Estimated Age: "+ data['estimated_age']);
        this.updateResponse(data)
        this.estimated_age = data['estimated_age'];
        this.lighting = data['lighting'][0];
        this.head_align = data['head_tilt'][0] + data['head_left_right'][0] + data['head_up_down'][0]
        this.face_detection =  data['face_detection']
        // console.log(data)
        // sending data to parent iframe
        var information = {
          estimated_age:  data['estimated_age'],
        };
        this.sendtoparent(information);
      });

      },200);

      
    
    },
    stopFrameRelay() {
      // Disconnect from the Socket.IO server
      if (this.$socket) {
        this.$socket.disconnect();
        this.$socket = null;
      }
    },

    resetpredictionlabel() {
      this.predictionResult = "--";
      this.predictionScore = " ";
      document.getElementById("prediction").style.color = "#000000";
    },
    ageGate(val){
      this.agelimit = val;
    }
    },
  };
  </script>
  <style>
    .analysis{
      z-index: 2;
    
    }
    .button{
      border: 1px solid #fff;
    color: #fff;
    padding: 10px;
    border-radius: 8px;
    display: inline-block;
    text-align: center;
    margin: 10px 10px 10px 10px;
    text-decoration:none;
    text-align: center;
    width:250px;
    height: 50px;
    font-weight: bold;
    }
    #stopbutton{
      border: 1px solid #fff;
    color: #fff;
    padding: 10px;
    border-radius: 8px;
    display: none;
    text-align: center;
    margin: 10px 10px 10px 10px;
    text-decoration:none;
    text-align: center;
    width:250px;
    height: 50px;
    font-weight: bold;
    /* display: none; */
  }
  .text-container{
    position: absolute; 
    background: transparent; 
    top: 0%; 
    right: 0%; 
    left: 0%; 
    pointer-events: none;
    /* background:rgba(255, 255, 255, 0.25); */
    /* text-shadow: -1px -1px 0 #493a3a, 1px -1px 0 #493a3a, -1px 1px 0 #493a3a, 1px 1px 0 #493a3a; */
    letter-spacing: 1px;
    -webkit-text-stroke: 0.5px #493a3a;
  }
  #videocase{
    position: relative;
    /* left:25%; */
    transform: rotateY(180deg);
    -webkit-transform:rotateY(180deg); /* Safari and Chrome */
    -moz-transform:rotateY(180deg); /* Firefox */
    border: 10px solid lightgrey;
    width: 100%;
    height: auto;


  }

  .ageai-title {
    color: var(--neutral-900, #111827);
    /* H1/Bold/Desktop */
    font-family: Mukta;
    font-size: 96px;
    font-style: normal;
    font-weight: 700;
    line-height: 112px; /* 116.667% */
    letter-spacing: -1.92px;
  }

  .ageai-button {
  border-radius: 8px;
  color: #fff;
  background: #6eaae5;
  text-transform: unset;
  width: 83px;
  height: 44px;
  }

  .result-message{
    text-align: center;
    font-weight: bold;
    font-size: 20px;
    color: grey;
    margin-top: 5%;
  }

  .timer{
    color: var(--neutral-900, #111827);
    /* H1/Bold/Desktop */
    font-family: Mukta;
    text-align: center;
    font-weight: bold;
    font-size: 130%;
    font-style: normal;
    margin-top: 5%;
  }

  #agegate-button21 {
  border-radius: 8px;
  background: #3aa56a !important;
  text-transform: unset;
  border: 2px solid #167d45;
  width: auto;
  height: 44px;
  }

  #agegate-button25 {
  border-radius: 8px;
  background: white !important;
  text-transform: unset;
  border: 2px solid #6eaae5;
  color: #6eaae5  !important;
  width: auto;
  height: 44px;
  }

  .thankmsg{
    color: var(--neutral-900, #111827);
    /* H1/Bold/Desktop */
    font-family: Mukta;
    text-align: center;
    font-weight: bold;
    font-size: 200%;
    font-style: normal;
    margin-top: 10%;
  }

  .linkmsg{
    color: var(--neutral-900, #111827);
    /* H1/Bold/Desktop */
    /* font-family: Mukta; */
    text-align: center;
    font-weight: bold;
    font-size: 130%;
    font-style: normal;
  }

  </style>

  
  
  
  
  